import { HowItWorksActions, HowItWorksModalActions } from "./actions";

export interface IHowItWorksModalState {
  open: boolean;
}

export const howItWorksModalReducer = (
  state: IHowItWorksModalState = { open: false },
  action: HowItWorksActions
) => {
  switch (action.type) {
    case HowItWorksModalActions.OPEN_HOW_IT_WORKS_MODAL: {
      return {
        open: true
      };
    }

    case HowItWorksModalActions.CLOSE_HOW_IT_WORKS_MODAL: {
      return {
        open: false
      };
    }

    default: {
      return state;
    }
  }
};
